// extracted by mini-css-extract-plugin
export default {"issueViewerContainer":"IssueViewer-module__issueViewerContainer--flht4"};